/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL21haW4vcG1zL3Byb2plY3QtZGV0YWlscy9hZGRpdGlvbmFsLXNlcnZpY2VzLW1haWxpbmctb3B0aW9ucy9hZGRpdGlvbmFsLXNlcnZpY2VzLW1haWxpbmctb3B0aW9ucy5jb21wb25lbnQuc2NzcyJ9 */"];
export { styles as styles };
